import { useEffect, useState } from 'react'
import { Button, Modal, Form, Spinner, Dropdown } from 'react-bootstrap'
import { Request } from '../../../Api/Requests/models'
import { useAutoLoad } from '../hooks/useAutoLoad'
import { BsHeartFill, BsPlusCircleFill } from 'react-icons/bs'
import { RejectRequestModal } from './RejectRequestModal'
import { useAutoLoadPromo } from '../hooks/useAutoLoadPromo'
import { openImage } from '../../../../../Utils/images'

interface OpenRequestModalProps {
    show: boolean
    onHide: () => void
    request: Request
}

export const OpenRequestModal = ({ show, onHide, request }: OpenRequestModalProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [showReject, setShowReject] = useState(false)
    const [form, setForm] = useState({
        recipient: request?.recipient ?? '',
        sender: request?.sender ?? ''
    })

    const { confirmAddCoins, loadingLoad } = useAutoLoad({ request, onHide, form })
    const { confirmAddPromo, loadingLoadPromo } = useAutoLoadPromo({ request, onHide, form, setDropdownOpen })

    const closeBothModals = () => {
        setShowReject(false)
        onHide()
    }

    useEffect(() => {
        setForm({
            recipient: request?.recipient ?? '',
            sender: request?.sender ?? ''
        })
    }, [request])


    const requestClosed = request?.status === 'approved' || request?.status === 'rejected'


    return (
        <>
            <RejectRequestModal show={showReject} onHide={() => setShowReject(false)} closeBothModals={closeBothModals} request={request} />

            <Modal show={show} onHide={onHide} size='lg' backdrop="static" keyboard={false} centered>

                <div className="border border-secondary rounded-3 px-4">
                    <Modal.Header closeButton>
                        <Modal.Title>Solicitud de {request.type === 'load' ? 'Carga' : 'Retiro'}<br /> <span className='text-primary'>{request.Player?.platformUser}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <div className='d-flex justify-content-between gap-2 align-items-center'>
                            <div className='text-center d-flex justify-content-center w-100 text-primary'>
                                El usuario {request.Player?.platformUser} desea {request.type === 'load' ? 'cargar' : 'retirar'} {request.amount} fichas.
                            </div>

                            <div className='d-flex flex-column gap-2'>
                                <div role='button'>
                                    <img src={request.base64invoice} alt="Comprobante" width={100} onClick={() => openImage(request.base64invoice)} />
                                    <div className='text-secondary text-center w-100 text-xxs'>Comprobante</div>
                                </div>
                            </div>
                        </div>
                        <hr />

                        <div className="mt-2">
                            Solicitud de <span className="text-primaryy">{request.type === 'load' ? 'Carga' : 'Retiro'}</span>
                        </div>
                        <div className="mt-2">
                            Cantidad: <span className="text-primaryy">{request.amount}</span>
                        </div>
                        <div className="mt-2">
                            Código Promoción: <span className="text-primaryy">{request.promoCode ?? '-'}</span>
                        </div>
                        {/* <div className="mt-2">
                        Remitente: <span className="text-primaryy">{request.sender}</span>
                    </div> */}
                        <div className="my-4">
                            Remitente <span className='text-warning'>*</span>
                            <Form.Control type="text" placeholder="Ingrese la cuenta" disabled={requestClosed} value={form.sender} onChange={(e) => setForm({ ...form, sender: e.target.value })} />
                        </div>
                        <div className="my-4">
                            Titular de la cuenta que recibió <span className='text-warning'>*</span>
                            <Form.Control type="text" placeholder="Ingrese la cuenta" disabled={requestClosed} value={form.recipient} onChange={(e) => setForm({ ...form, recipient: e.target.value })} />
                        </div>

                        <div className='mt-2 text-warning text-center'>
                            <span className='text-white'>Verifica que estos datos sean correctos, y validalos con tu cuenta bancaria.  <br />
                                <span className='text-warning'>Edita remitente y titular de la cuenta que recibió si no coinciden con el comprobante.</span>
                            </span>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>

                            <div className='d-flex align-items-center gap-2'>
                                {/* <Button variant="secondary" onClick={onHide} disabled={loadingLoad}>
                                    Cancelar
                                </Button> */}
                                {request?.status === 'pending' && <Button variant="danger" onClick={() => setShowReject(true)} disabled={loadingLoad}> Rechazar </Button>}
                            </div>


                            {request?.status === 'pending' &&
                                <div className='d-flex align-items-center gap-2'>
                                    <div className='d-flex align-items-center gap-2'>
                                        <Button variant="primary" onClick={() => setDropdownOpen(!dropdownOpen)} className='d-flex align-items-center gap-2'>
                                            <BsHeartFill size={18} />
                                            Con bonificación
                                        </Button>
                                        <Dropdown show={dropdownOpen} align='start'>
                                            <Dropdown.Menu className='text-white dark-dropdown-custom '>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 10 })} >Carga + 10%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 15 })} >Carga + 15%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 20 })} >Carga + 20%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 25 })} >Carga + 25%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 30 })} >Carga + 30%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 35 })} >Carga + 35%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 40 })} >Carga + 40%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 50 })} >Carga + 50%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddPromo({ bonus: 60 })} >Carga + 60%</Dropdown.Item>
                                                <Dropdown.Item className="text-secondary" onClick={(event) => confirmAddCoins({ isBonus: true })}>Bonificación total</Dropdown.Item>
                                            </Dropdown.Menu>

                                        </Dropdown>
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                        <Button variant="primary" className='d-flex align-items-center gap-2' onClick={() => confirmAddCoins({ isBonus: false })} disabled={loadingLoad || loadingLoadPromo}>
                                            {loadingLoad || loadingLoadPromo ? <Spinner animation="border" size="sm" /> : <BsPlusCircleFill size={20} />} Cargar
                                        </Button>
                                    </div>
                                </div>
                            }

                            {request?.status === 'approved' &&
                                <div className='d-flex align-items-center gap-2'>
                                    <div className='text-success'>
                                        La carga ya fue aprobada.
                                    </div>
                                </div>
                            }

                            {request?.status === 'rejected' &&
                                <div className='d-flex align-items-center gap-2 mx-2'>
                                    <div className='text-danger'>
                                        La carga fue rechazada.
                                        <br />
                                        <span className='text-secondary'>Motivo: {request.reason}</span>
                                    </div>
                                </div>
                            }


                        </div>
                    </Modal.Footer>
                </div >
            </Modal >
        </>
    )
}
